<template>
    <div class="d-inline-block ml-1">
        <span v-if="currency === 'EUR'">&euro;</span>
        <span v-else-if="currency === 'USD'">&dollar;</span>
        <span v-else-if="currency === 'GBP'">&pound;</span>
        <span v-else>
            <i class="fas fa-question-circle"/>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        currency: String
    }
}
</script>
